import React from "react";
import _ from "lodash";
import moment from "moment";
import submit from "submit-form";
import convert from "convert-units";
import getDayRangeString from "../../../utils/day-range-string";
import ShareModal from "../../../parts/modals/share";
import CalendarAddExerciseModal from "../../../parts/modals/calendar-add-exercise";
import ProgressionModal from "../../../parts/modals/progression";
import SwapExerciseModal from "../../../parts/modals/swap-exercise";
import SingleDayCycleBar from "./components/SingleDayCycleBar";
import getSessionOrder from "../../../utils/get-session-order";
import { getActiveDayStats } from "../../../utils/daily-stats";
import JWPlayerVideoModal from "../../../parts/modals/jwplayer-video";
import QuickMetrics from "./components/QuickMetrics";
import TopBarSingleDay from "./components/TopBarSingleDay";
import {
  checkOtherExercise,
  validateSet,
} from "../../../utils/exercise-validations";
import Avatar from "../../../parts/avatar";
import PhotoModal from "../../athlete-portal/calendar/progress-photos/PhotoModal";
import Picture from "../../athlete-portal/calendar/progress-photos/Picture";
import DaylyWorkoutHeader from "./DaylyWorkoutHeader";
import ExerciseFrame from "./ExerciseFrame";
import SvgIcon from "../../../parts/SvgIcon";

// Constants
const {
  DATE_FORMATS: { DATE_DAY_FORMAT, UTC },
  S3,
  PRIMARIESWITHOLYMPIC,
} = require("../../../constants");

class View extends React.Component {
  constructor(props, context) {
    super(props);

    const { activeUser } = context.locals;
    this.user = activeUser;
    this.state = {
      notes: "",
      openQuickEditNotes: false,
      openQuickEdit: false,
      exercises: [],
      sendToCoach: false,
      photoModal: {
        open: false,
        type: "",
        pictureImg: "",
      },
    };
    this.loadInputs = [];
    this.intensityInputs = [];

    this.handleDuplicateExercise = this.handleDuplicateExercise.bind(this);
    this.openQuickEditMode = this.openQuickEditMode.bind(this);
    this.handleQuickEditChange = this.handleQuickEditChange.bind(this);
    this.saveQuickEdit = this.saveQuickEdit.bind(this);
    this.closeQuickEditMode = this.closeQuickEditMode.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal(pictureImg = "", type = "") {
    this.setState({
      photoModal: {
        open: this.state.photoModal.open ? false : true,
        type,
        pictureImg: S3.toCDN(pictureImg),
      },
    });
  }

  handleDuplicateExercise(body) {
    submit("/actions/exercise/duplicate-from-single-day", {
      method: "POST",
      body,
    });
  }

  openQuickEditMode(e) {
    e.preventDefault();
    this.setState((prevState) =>
      Object.assign({}, prevState, { openQuickEdit: true })
    );
  }

  closeQuickEditMode(e) {
    e && e.preventDefault();
    document.getElementById("quick-edit").reset();
    this.setState((prevState) =>
      Object.assign({}, prevState, { openQuickEdit: false })
    );
  }

  handleQuickEditChange({ target: { name, value } }, exId, setId) {
    const { locals } = this.context;
    const exercises = _.cloneDeep(this.state.exercises);
    const exerciseIndex = exercises.findIndex((ex) => ex._id == exId);
    const exercise =
      exercises[exerciseIndex] ||
      _.cloneDeep(_.get(this.context.locals, "editExercises", [])).find(
        (ex) => ex._id == exId
      ) ||
      _.cloneDeep(_.get(this.context.locals, "activeExercises", [])).find(
        (ex) => ex._id == exId
      ) ||
      {};

    const set = _.get(exercise, ["sets", setId], false);

    if (set && set[name] !== value && name !== "exerciseType") {
      set[name] = value;
      const primary = _.get(exercise, "primary");
      const repMax =
        exercise.type != "secondary"
          ? _.get(
              exercise,
              `repMaximums.${primary}`,
              _.get(this.context.locals.activeUser, `repMaximums.${primary}`, 0)
            )
          : exercise.secondaryRepMaximum;

      // ensure load and percentRepMax are in sync
      if (name === "load") {
        if (this.context.locals.activeUser.units === "imperial")
          set.load = _.round(convert(value).from("lb").to("kg"), 2);
        if (exercise.type !== "assistant")
          set.percentRepMax = _.round((set.load / repMax) * 100, 1);
      }

      if (name === "percentRepMax")
        set.load = _.round((repMax * set.percentRepMax) / 100, 2);

      const loadInput = this.loadInputs[`${exId}_${setId}`];
      if (loadInput) {
        if (name === "percentRepMax") {
          let loadToShow = set.load;
          if (this.context.locals.activeUser.units === "imperial") {
            loadToShow = _.round(convert(loadToShow).from("kg").to("lb"), 2);
          }
          loadInput.value = loadToShow;
        }
        if (!this.intensityInputs[`${exId}_${setId}`]) {
          this.intensityInputs[`${exId}_${setId}`] = { value: 0 };
        }
        this.intensityInputs[`${exId}_${setId}`].value = set.percentRepMax;
      }

      const validatedSet = validateSet({
        exercise,
        set,
        locals,
        field: name,
      });
      if (validatedSet) {
        exercise.sets[setId] = validatedSet;

        this.setExersicesStates(exercise, exercises, exerciseIndex);
      } else {
        // revert to original value
        document.getElementById(`${exId}_${setId}_${name}`).value = _.cloneDeep(
          _.get(this.context.locals, "activeExercises", [])
        ).find((ex) => ex._id == exId).sets[setId][name];
      }
    } else if (name === "notes") {
      exercise.notes = value === "" ? " " : value;

      this.setExersicesStates(exercise, exercises, exerciseIndex);
    } else if (name === "exerciseType") {
      const { movement, repMaximum, newPrimary } = value;
      const sets = _.get(exercise, "sets", false);

      // if the movement chosen is a primary, change to a primary
      if (PRIMARIESWITHOLYMPIC.includes(movement)) {
        // setting new values
        exercise.type = "primary";
        exercise.primary = movement;
        // resetting secondary and secondary RM
        exercise.secondary = "null";
        exercise.secondaryRepMaximum = 0;
        exercise.parameters = "null";
        // updating the values of each set in the exercise
        sets.map((currentSet, idx) => {
          if (
            currentSet.load &&
            currentSet.percentRepMax &&
            currentSet.load >= 0 &&
            currentSet.percentRepMax >= 0
          ) {
            currentSet.load = _.round(
              (repMaximum * currentSet.percentRepMax) / 100,
              2
            );
            currentSet.percentRepMax = _.round(
              (currentSet.load / repMaximum) * 100,
              1
            );
          }

          // updating the load shown
          const loadInput = this.loadInputs[`${exId}_${idx}`];
          if (loadInput) {
            let loadToShow = currentSet.load;
            const { units } = this.context.locals.activeUser;

            if (units === "imperial") {
              loadToShow = _.round(convert(loadToShow).from("kg").to("lb"), 2);
            }
            loadInput.value = loadToShow;
          }
          // Making sure no values are invalid after any changes
          if (!currentSet.load || currentSet.load === null) currentSet.load = 0;
          if (!currentSet.percentRepMax || currentSet.percentRepMax === null)
            currentSet.percentRepMax = 0;
        });
      }
      // if repMaximum is undefined and isAssistant = true then it is assistant
      else if (!repMaximum && newPrimary === "assistant") {
        exercise.type = "assistant";
        exercise.primary = "assistant";
        exercise.secondary = movement;
        exercise.secondaryRepMaximum = 0;
        if (value.parameters) exercise.parameters = value.parameters;
      }
      // else its a secondary
      else {
        // change type from primary/assistant to secondary and set new values
        exercise.type = "secondary";
        exercise.primary = newPrimary;
        exercise.secondary = movement;
        exercise.secondaryRepMaximum = repMaximum;
        exercise.parameters = "null";
        // updating the values of each set in the exercise
        sets.map((currentSet, idx) => {
          if (
            currentSet.load &&
            currentSet.percentRepMax &&
            currentSet.load >= 0 &&
            currentSet.percentRepMax >= 0
          ) {
            currentSet.load = _.round(
              (repMaximum * currentSet.percentRepMax) / 100,
              2
            );
            currentSet.percentRepMax = _.round(
              (currentSet.load / repMaximum) * 100,
              1
            );
          }

          // updating the load shown
          const loadInput = this.loadInputs[`${exId}_${idx}`];
          if (loadInput) {
            let loadToShow = currentSet.load;
            const { units } = this.context.locals.activeUser;

            if (units === "imperial") {
              loadToShow = _.round(convert(loadToShow).from("kg").to("lb"), 2);
            }
            loadInput.value = loadToShow;
          }
          // Making sure no values are invalid after any changes
          if (!currentSet.load || currentSet.load === null) currentSet.load = 0;
          if (!currentSet.percentRepMax || currentSet.percentRepMax === null)
            currentSet.percentRepMax = 0;
        });
      }

      this.setExersicesStates(exercise, exercises, exerciseIndex, true);
    }
  }

  setExersicesStates(
    exercise,
    exercises,
    exerciseIndex,
    saveAfterChange = false
  ) {
    // if exercise already exists in state
    if (exerciseIndex > -1) exercises[exerciseIndex] = exercise;
    // otherwise push to exercises
    if (exerciseIndex < 0) exercises.push(exercise);

    this.setState(
      (prevState) => Object.assign({}, prevState, { exercises }),
      saveAfterChange
        ? () => this.saveQuickEdit({ preventDefault: () => {} }, false)
        : undefined
    );
  }

  saveQuickEdit(e, close = true) {
    e.preventDefault();
    if (
      this.state.exercises === undefined ||
      this.state.exercises.length === 0
    ) {
      this.closeQuickEditMode();
      this.setState({ exercises: [] });
      submit("/actions/exercise/quick-edit/cancel");
    } else if (checkOtherExercise(this.state.exercises)) {
      submit("/actions/exercise/quick-edit?reqSource=calendar", {
        method: "POST",
        body: { exercises: this.state.exercises },
      });
      if (close) {
        this.closeQuickEditMode();
        this.setState({ exercises: [] });
      }
    }
  }

  openQuickEditNotes() {
    const workoutNote = this.context.locals.workoutNote;
    this.setState(
      {
        openQuickEditNotes: true,
        notes:
          workoutNote && workoutNote.note && workoutNote.note.note
            ? workoutNote.note.note
            : "",
      },
      () => {
        document.getElementById("notes-textarea")?.focus();
      }
    );
  }

  closeQuickEditNotes() {
    this.setState({
      openQuickEditNotes: false,
      sendToCoach: false,
    });
  }

  handleNoteChange(value) {
    this.setState({ notes: value });
  }

  handleCheckboxChange() {
    this.setState({ sendToCoach: !this.state.sendToCoach });
  }

  saveQuickEditNotes() {
    const { originalQueryDate } = this.context.locals;
    submit("/actions/exercise/quick-edit-note", {
      method: "POST",
      body: {
        note: this.state.notes,
        date: originalQueryDate,
        sendToCoach: this.state.sendToCoach,
      },
    });

    if (
      this.context.locals.workoutNote &&
      this.context.locals.workoutNote.note &&
      this.context.locals.workoutNote.note.note
    ) {
      this.context.locals.workoutNote.note.note = this.state.notes;
    } else {
      this.context.locals.workoutNote = {
        note: { note: this.state.notes },
      };
    }

    this.closeQuickEditNotes();
  }

  renderBodyPhotos(activeDay = null) {
    const {
      locals: { dailyStats, query },
    } = this.context;
    const existPhotos =
      dailyStats.find(
        (stat) => stat.bodyPhotos && activeDay.isSame(stat.date)
      ) || false;
    if (!existPhotos) return null;
    const { athlete } = query;
    const urlStart = athlete ? "/athlete-portal/metrics" : "/dashboard/metrics";
    const urlEnd = athlete ? `&athlete=${athlete}` : "";
    const date = activeDay.format(DATE_DAY_FORMAT);
    return (
      <div className="progress-photo-wrapper">
        <span>Progress Photos</span>
        <div className="photos-container">
          {["front", "back", "side"].map((photoType, idx) => {
            const pictureSrc = existPhotos.bodyPhotos[photoType] || null;
            return (
              <Picture
                key={idx}
                src={pictureSrc ? pictureSrc.s3Path : pictureSrc}
                toggleModal={this.toggleModal}
                className="body-photo"
                photoType={photoType}
                loaded
              />
            );
          })}
        </div>
        <a
          href={`${urlStart}/progress-photos?view=day&date=${date}${urlEnd}`}
          className="see-all"
        >
          See all
        </a>
      </div>
    );
  }

  renderNotes({ notes, coachNotes, athleteInfo }) {
    return (
      <div className="notes-container">
        <div className="athlete-notes">
          <label>Notes</label>
          <>
            {!this.state.openQuickEditNotes ? (
              <div
                className="edit-mode"
                onClick={() => this.openQuickEditNotes()}
              >
                {notes.length && notes.trim().length
                  ? notes
                  : "Click to add/edit notes"}
              </div>
            ) : (
              <div className="edit-mode editing">
                <textarea
                  value={this.state.notes || ""}
                  onChange={({ target: { value } }) =>
                    this.handleNoteChange(value)
                  }
                  id="notes-textarea"
                />
                <div className="button-container">
                  <button
                    data-button-type="primary"
                    onClick={() => this.saveQuickEditNotes()}
                  >
                    Save
                  </button>
                  <button
                    data-button-type="secondary"
                    onClick={() => this.closeQuickEditNotes()}
                  >
                    <SvgIcon
                      src="/img/new-icons/red-cross.svg"
                      noFilterOnLight={true}
                    />
                  </button>
                </div>
              </div>
            )}
          </>
        </div>
        {athleteInfo.coach && coachNotes && coachNotes.trim().length ? (
          <div className="coach-notesx">
            <label>Coach Notes</label>
            <div className="edit-mode !cursor-default">
              <span>{coachNotes}</span>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const { locals } = this.context;
    const {
      query,
      activeExercises,
      editExercises,
      editCycle,
      activeUser,
      activeUserToRequest,
      activeUser: { isCoachEditing },
      cycleDetail = {},
      workoutNote,
      workoutCoachNote,
      dailyStats,
      pathname,
    } = locals;
    const user = this.user;
    const notes =
      workoutNote && workoutNote.note && workoutNote.note.note
        ? workoutNote.note.note
        : "";

    const coachNotes =
      workoutCoachNote && workoutCoachNote.note && workoutCoachNote.note.note
        ? workoutCoachNote.note.note
        : "";

    const nav = query.nav || "0";

    const program = _.find(_.get(editCycle, "programs", []), {
      order: cycleDetail.program,
    });
    const sessionOrderInProgram = program
      ? getSessionOrder(
          program,
          cycleDetail.programWeek,
          cycleDetail.programSession
        )
      : undefined;
    const session = _.find(_.get(program, "sessions", []), {
      order: sessionOrderInProgram,
    });

    const activeDay = moment(query.date, DATE_DAY_FORMAT);
    const dayStats = getActiveDayStats({
      activeDayUtc: parseInt(activeDay.format(UTC)),
      stats: dailyStats,
    });

    const { photoModal, openQuickEditNotes } = this.state;

    return (
      <main className="Calendar">
        <TopBarSingleDay query={query} activeDay={activeDay} />

        <section className="Calendar-Day">
          {editCycle && (
            <SingleDayCycleBar
              exerciseCycleDetails={cycleDetail}
              cycle={editCycle}
              cycleExercises={editExercises}
              exercises={activeExercises}
              activeDay={activeDay}
              setSessionOrder={this.setSessionOrder}
              nav={nav}
              pathname={pathname}
            />
          )}

          <section className="Daily-Workout">
            <DaylyWorkoutHeader
              activeExercises={activeExercises}
              sessionOrderInProgram={sessionOrderInProgram}
              query={query}
              openQuickEditMode={this.openQuickEditMode}
              handleRemove={(e) => handleRemove(e, activeDay)}
              dailyStats={dayStats}
              activeUser={activeUser}
              activeUserToRequest={activeUserToRequest}
              activeDay={activeDay}
            />

            <ExerciseFrame
              activeExercises={activeExercises}
              openQuickEdit={this.state.openQuickEdit}
              editCycle={editCycle}
              program={program}
              session={session}
              fromMetric={locals.fromMetric}
              activeUser={locals.activeUser}
              handleDuplicate={this.handleDuplicateExercise}
              openQuickEditMode={this.openQuickEditMode}
              handleQuickEditChange={this.handleQuickEditChange}
              loadInputs={this.loadInputs}
              intensityInputs={this.intensityInputs}
              query={query}
              saveQuickEdit={(e) => this.saveQuickEdit(e)}
              exercises={this.state.exercises}
              closeQuickEditMode={this.closeQuickEditMode}
              handleRemove={(e) => handleRemove(e, activeDay)}
            />
            <footer className="footer-notes">
              {this.renderNotes({ notes, coachNotes, athleteInfo: user })}
              {this.renderBodyPhotos(activeDay)}
            </footer>
          </section>
          <hr />
          <QuickMetrics locals={locals} />
        </section>

        {isCoachEditing && (
          <div className="Coach-Edit">
            <img src="/img/icons/edit.svg" width="20" height="20" />
            Your coach is editing your calendar. You will not be able to save
            changes at this time.
          </div>
        )}
        {photoModal.open && !openQuickEditNotes ? (
          <PhotoModal toggleModal={this.toggleModal} photo={photoModal} />
        ) : null}
      </main>
    );
  }
}

function handleRemove(e, date) {
  if (confirm("Are you sure you want to remove this workout?")) {
    e.preventDefault();

    submit(
      `/actions/exercise/unschedule-workout?date=[${date.format(
        DATE_DAY_FORMAT
      )}]`,
      {
        method: "POST",
        body: {
          days: [date.format(DATE_DAY_FORMAT)],
          source: "calendarDayView",
        },
      }
    );
  }
}

const CalendarSingleDay = (app) => {
  app.get("/", async ({ req, res, locals, load, api, fail }, next) => {
    if (req.query.view !== "day") return next();
    const { query } = req;
    const { units } = locals;
    const user = locals.activeUser._id;
    const modal = _.get(query, "modal", {});

    _.defaults(query, {
      units,
      date: moment.utc(query.date).format(DATE_DAY_FORMAT),
      zoneType: "total",
    });

    locals.originalQueryDate = "" + query.date;

    if (query.date instanceof Date)
      query.date = moment.utc(query.date).format(DATE_DAY_FORMAT);
    const startDate = moment.utc(query.date, DATE_DAY_FORMAT).startOf("day");
    const endDate = moment.utc(query.date, DATE_DAY_FORMAT).endOf("day");

    await Promise.all([
      load("activeExercises", {
        start: startDate,
        end: endDate,
      }),
      load("currentYearExercises", {
        start: startDate,
        end: endDate,
      }),
      load("workoutNote", locals.originalQueryDate),
      load("dayPersonalRecords", {
        end: moment
          .utc(locals.query.date, DATE_DAY_FORMAT)
          .endOf("day")
          .format(UTC),
      }),
      load("dailyStats", {}),
      load("nutritionPlans", {}),
    ]);

    if (locals.activeUser.coach) {
      await load(
        "workoutCoachNote",
        locals.originalQueryDate,
        locals.activeUser._id,
        locals.activeUser.coach._id
      );
    }

    if (locals.activeExercises) {
      const exerciseWithCycle =
        locals.activeExercises.find((e) => e.cycle) || {};
      locals.cycleDetail = exerciseWithCycle.cycle;
      const cycleId = _.get(locals, "cycleDetail.id", false);
      if (cycleId)
        await Promise.all([
          load("editCycle", {
            cycle: cycleId,
            proxyAthlete: query.athlete,
          }),
          load("editExercises", {
            cycle: cycleId,
            isScheduled: true,
            proxyAthlete: query.athlete,
          }),
        ]);
    }
    if (modal.type === "share" && !modal.snapshot) {
      // create share link
      try {
        modal.snapshot = (
          await (
            await api("snapshot", {
              method: "POST",
              body: {
                type: "workout",
                data: JSON.stringify(
                  _.chain(locals)
                    .pick(["activeExercises"])
                    .assign({
                      start: startDate.toJSON(),
                      end: endDate.toJSON(),
                    })
                    .value()
                ),
              },
            })
          ).json()
        )._id;

        modal.date = getDayRangeString([startDate, endDate]);

        return res.refreshWith({ modal });
      } catch (e) {
        console.error(e.stack || e);
        fail(400, "Error creating share link.");
      }
    }

    const editExercise = query.editMode
      ? _.find(locals.activeExercises, { _id: query.exercise })
      : {};

    locals.modal = {
      "exercise-set-video": (
        <JWPlayerVideoModal
          mediaId={query.mediaId}
          originalId={query.originalId}
          athleteId={query.uploaderId || locals.activeUser._id}
        />
      ),
      "calendar-add-exercise": (
        <CalendarAddExerciseModal editExercise={editExercise} />
      ),
      share: <ShareModal />,
      progression: <ProgressionModal />,
      "swap-exercise": <SwapExerciseModal exercise={editExercise} />,
    }[modal.type];
    res.body = <View />;
  });
};

export default CalendarSingleDay;
